import clsx from 'clsx';
import styles from './etiqueta.module.scss';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
import __isEmpty from 'lodash/isEmpty';
import { EtiquetaProps } from './Etiqueta.types';

export default function Etiqueta(props: Readonly<EtiquetaProps>) {
    const { titol, textBoto, enllac, tema, estil, className } = props;

    const stylesEtiqueta = clsx(
        styles.etiqueta,
        !__isEmpty(estil) && styles[estil as string],
        !__isEmpty(tema) && styles[tema as string],
        !__isEmpty(className) && className
    );

    return (
        <div className={stylesEtiqueta}>
            <span className={styles.titol}>{titol}</span>
            {enllac && textBoto && (
                // @ts-ignore - Enllac is a JSX component without proper TypeScript definitions
                <Enllac href={enllac} className={styles.boto} title={textBoto}>
                    {textBoto}
                </Enllac>
            )}
        </div>
    );
}
